export default "__VITE_ASSET__eIKNEILh__"